import { AnyAction, Store, Unsubscribe } from "redux";

import { IStoreState } from "interfaces/storeState";

type ISelector<TSelected = unknown, TParams = unknown[]> = (state: IStoreState, ...params: TParams[]) => TSelected;

export class AppStateProvider {
  private static store: Store<IStoreState>;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static setup(store: Store<IStoreState>) {
    this.store = store;
  }

  static dispatch(action: AnyAction): AnyAction {
    if (!this.store) {
      throw new Error("Store is not passed to state provider");
    }

    return this.store.dispatch(action);
  }

  static selectFromState<TSelected = unknown, TParams = unknown[]>(
    selector: ISelector<TSelected, TParams>,
    ...args: TParams[]
  ): TSelected {
    if (!this.store) {
      throw new Error("Store is not passed to state provider");
    }

    return selector(this.store.getState(), ...args);
  }

  static getState(): IStoreState {
    if (!this.store) {
      throw new Error("Store is not passed to state provider");
    }
    return this.store.getState();
  }

  static subscribe(listener: VoidFunction): Unsubscribe {
    if (!this.store) {
      throw new Error("Store is not passed to state provider");
    }
    return this.store.subscribe(listener);
  }
}

export type IAppStateProvider = Pick<typeof AppStateProvider, "dispatch" | "getState" | "subscribe">;
